//
// logError
//
// Always logs to console. If a code is provided, also reports to backend.
//

import config from './config';
import getPWADisplayMode from './getPWADisplayMode';
import logColor from './logColor';
import simplifyUserAgent from './simplifyUserAgent';

let lastReportTime = 0;

const logError = (txt, code, moreInfo) => {
  logColor(txt, 'red');

  if (!code) return;

  try {
    const now = Date.now();
    if ((now - lastReportTime) < 10000) return;
    lastReportTime = now;

    const url = `${config.town.back.urlPrefix}logs/internal/new`;

    const extra = ((moreInfo) && (typeof moreInfo === 'object')) ? moreInfo : null;
    const webApp = getPWADisplayMode();

    fetch(
      url,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          code: code.slice(0, 90),
          info: {
            ...extra,
            rev: config.rev,
            url: window.location.href,
            userAgent: simplifyUserAgent(),
            ...((webApp !== 'browser') && { webApp }),
          },
        }),
        keepalive: true,
      },
    ).catch(() => {});
  } catch {
    // Never let error reporting break the app
  }
};

export default logError;
